import IndividualUnitReportData from './IndividualUnitReportData';

export default IndividualUnitReportData;
